import { pkg } from '@carbon/ibm-products';

pkg._silenceWarnings(true);
pkg.component.EditInPlace = true;
pkg.component.SidePanel = true;
